/**
 * Version - Portal release notes using shared VersionInfo component
 */
import React from "react";
import { VersionInfo } from "@sophy/shared-ui";

// Portal-specific release notes
const portalReleaseNotes = [
  {
    version: "24.8",
    date: "10.09.26",
    description:
      "Wochenziel, Serie und Meilensteine in der Programmübersicht; Fortschritt, Weg und Wohlbefinden im Programm; Abschluss-Ansicht nach dem Training; Neuer Menüpunkt Meilensteine; Erinnerungen per Push-Benachrichtigung und Installation als App (Einstellungen → Benachrichtigungen); Schnellere Programmübersicht und Detailseite",
  },
  {
    version: "24.7",
    date: "13.07.26",
    description: "Überarbeitete Einstellungen mit verbesserter mobiler Ansicht; Diverse Verbesserungen und Bugfixes",
  },
  {
    version: "24.6",
    date: "24.09.25",
    description: "Neue Funktionen: Fragebögen; Feedback; Benachrichtigungen an Physio; Physio Map",
  },
  {
    version: "24.5",
    date: "07.07.25",
    description: "Neue Funktionen: Kalenderansicht; Programmübersicht",
  },
  {
    version: "24.4",
    date: "13.06.25",
    description: "Neue Funktionen: Öffentliches Programm; Mein Physiotherapeut; Mein Material; Mein Kontakt",
  },
  {
    version: "24.3.1",
    date: "18.09.24",
    description: "Anpassung Feedback-Anzeige",
  },
  {
    version: "24.3",
    date: "03.09.24",
    description: "Neuer Menüpunkt Materialien (Beta)",
  },
  {
    version: "24.2",
    date: "03.04.24",
    description: "Menüanpassung Mobile; Case insensitive für Mailadresse bei Login",
  },
  {
    version: "24.1",
    date: "29.02.24",
    description: "Fixes",
  },
  {
    version: "23.0.4",
    date: "25.10.23",
    description: "Programm als Slideshow; Mein Physiotherapeut",
  },
  {
    version: "23.0.3",
    date: "17.10.23",
    description: "Leichte Anpassungen Layout",
  },
  {
    version: "23.0.2",
    date: "29.03.23",
    description: "Diverse Bugfixes",
  },
  {
    version: "23.0.1",
    date: "01.03.23",
    description: "Release mit Standard-Features aus der Version 22 mit neu überarbeitetem Design",
  },
];

export default function Version() {
  return (
    <VersionInfo 
      releaseNotes={portalReleaseNotes}
      dateLabel="Datum"
      descriptionLabel="Kurzbeschreibung"
    />
  );
}
